import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";

const API = process.env.REACT_APP_API_URL

export default function PixPayment() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [cobranca, setCobranca] = useState(null);
  const [erro, setErro] = useState("");
  const [copiado, setCopiado] = useState(false);

  const buscarCobranca = async () => {
    try {
      const res = await axios.get(`${API}/cobrancas/${id}`);
      const dados = res.data;
      setCobranca(dados);

      if (dados.metodo === "card" && dados.link) {
        window.location.href = dados.link;
      }

      if (dados.status === "approved" && dados.pagamento_id) {
        navigate(`/comprovante?payment_id=${dados.pagamento_id}`);
      }
    } catch (err) {
      setErro("Cobrança não encontrada");
    }
  };

  useEffect(() => {
    buscarCobranca();
    const intervalo = setInterval(buscarCobranca, 5000);
    return () => clearInterval(intervalo);
  }, [id]);

  const copiarCodigo = () => {
    if (cobranca?.qr_code) {
      navigator.clipboard.writeText(cobranca.qr_code)
        .then(() => {
          setCopiado(true);
          setTimeout(() => setCopiado(false), 2000);
        });
    }
  };

  if (erro) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4">
        <div className="bg-white p-6 rounded-xl shadow-lg max-w-md w-full text-center">
          <h1 className="text-xl font-bold text-red-600 mb-4">Erro</h1>
          <p className="mb-4">{erro}</p>
          <button 
            className="bg-indigo-600 text-white px-4 py-2 rounded"
            onClick={() => navigate('/')}
          >
            Voltar
          </button>
        </div>
      </div>
    );
  }

  if (!cobranca) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <p>Carregando...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="bg-white p-6 rounded-xl shadow-lg max-w-md w-full">
        <h1 className="text-2xl font-bold mb-4 text-center">Pagamento via PIX</h1>
        <div className="text-center mb-6">
          <p className="text-lg font-semibold">Valor: <span className="text-green-600">R$ {Number(cobranca.valor).toFixed(2)}</span></p>
          <p className="text-sm text-gray-600 mt-1">Escaneie o QR Code abaixo ou copie o código</p>
        </div>
        
        {cobranca.qr_code_base64 && (
          <div className="mb-6 flex justify-center">
            <img 
              src={`data:image/png;base64,${cobranca.qr_code_base64}`} 
              alt="QR Code PIX"
              className="w-64 h-64 border border-gray-300 rounded-lg"
            />
          </div>
        )}
        
        {cobranca.qr_code && (
          <div className="mb-6">
            <div className="flex justify-between items-center mb-2">
              <p className="font-semibold">Código PIX:</p>
              <button
                className={`text-sm px-3 py-1 rounded ${copiado ? 'bg-green-500 text-white' : 'bg-indigo-600 text-white'}`}
                onClick={copiarCodigo}
              >
                {copiado ? 'Copiado!' : 'Copiar Código'}
              </button>
            </div>
            <div className="bg-gray-100 p-3 rounded break-all text-sm font-mono">
              {cobranca.qr_code}
            </div>
          </div>
        )}

        <div className="text-center text-sm text-gray-500 mt-6">
          {cobranca.status === "approved" ? (
            <p className="text-green-600 font-semibold">Pagamento confirmado! ✅</p>
          ) : (
            <>
              <p>Aguardando pagamento...</p>
              <p className="mt-2">Este QR Code expira em 30 minutos.</p>
            </>
          )}
        </div>

        {cobranca.status === "approved" && cobranca.pagamento_id && (
          <div className="mt-6 flex justify-center">
            <button
              className="bg-green-600 hover:bg-green-700 text-white font-bold px-4 py-2 rounded shadow"
              onClick={() => navigate(`/comprovante?payment_id=${cobranca.pagamento_id}`)}
            >
              Ver Comprovante
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
